import { actionTypes } from 'reducer/actionType';

export const conditionalOptions = [
  {
    page: actionTypes.PAGE_ONE,
    title: 'Which of your original symptoms are you still experiencing? ',
    subTitle: 'Choose all that apply',
    options: [
      'Redness',
      'Swelling',
      'Discoloration',
      'Flaking',
      'Drainage',
      'Open Wound',
      'Nail Thickening',
    ],
  },
  {
    page: actionTypes.PAGE_TWO,
    title: 'What is your current pain level? ',
    subTitle: '',
    options: [],
  },
  {
    page: actionTypes.PAGE_THREE,
    title: 'Which of the following at-home activities have you been trying? ',
    subTitle: 'Choose all that apply',
    options: [
      'Ice',
      'Stretching',
      'Rest',
      'Elevation',
      'Soaks',
      'Over the counter pain reliever',
      'Shoe change',
    ],
  },
];
